import { ApiResponse } from 'apisauce'

export interface GaussIframeUrlResource {
  url: string
}

export const deserializeGaussIframeUrlResponse = (
  response: ApiResponse<GaussIframeUrlResource>,
): ApiResponse<string> => {
  const { data, ...responseRest } = response

  if (!response.ok || !data) {
    return { ...responseRest }
  }

  return {
    ...responseRest,
    data: data.url,
  }
}
